/* eslint-disable @typescript-eslint/no-explicit-any */
// src/services/errorHandle.ts

export interface AppError {
  name: string;
  message: string;
  field?: string; // maps to form field name
  status?: number;
}

// Mapping of Prisma field names → Human-friendly UI labels
const fieldLabelMap: Record<string, string> = {
  // GeneralDiary
  reportPrintedOn: "Report Printed On (Date)",
  reportPrintedByName: "Report Printed By (Name)",
  reportPrintedByRank: "Report Printed By (Rank)",
  signatureName: "Signature (Name)",
  signatureRank: "Signature (Rank)",
  signatureIdNo: "Signature (ID Number)",
  gdNo: "GD Number",
  gdDateTime: "GD Date & Time",
  gdType: "GD Type",
  entryForOfficer: "Entry For Officer",
  informationType: "Information Type",
  underSection: "Under Section",
  officerName: "Officer Name",
  caseType: "Case Type",
  subject: "Subject",
  incidentDescription: "Incident Description",
  actionTaken: "Action Taken",

  // Document
  fileName: "File Name",
  originalName: "Original File Name",
  fileSize: "File Size",
  mimeType: "File Type",
  filePath: "File Path",
  documentType: "Document Type",

  // User
  email: "Email",
  phone: "Phone Number",
  badgeNumber: "Badge Number",
  name: "Name",
  password: "Password",

  // Victim / Suspect
  fatherName: "Father’s Name",

  // Report
  title: "Report Title",
  dateFrom: "Report Date (From)",
  dateTo: "Report Date (To)",

  // PoliceStation
  code: "Police Station Code",
};

// Extract field name from Prisma error
function extractFieldFromPrismaMessage(message: string): string | undefined {
  const match = message.match(/Invalid value for argument `(.*?)`/);
  return match ? match[1] : undefined;
}

/**
 * Normalizes errors into user-friendly object
 */
export function parseError(error: any): AppError {
  // Axios/Fetch backend errors
  if (error?.response) {
    const backendError = error.response.data?.error || error.response.data;

    return {
      name: backendError?.name || "BackendError",
      message: backendError?.message || "Something went wrong on the server.",
      status: error.response.status,
    };
  }

  // Prisma Validation/Request errors
  if (error?.name?.includes("Prisma")) {
    const field = extractFieldFromPrismaMessage(error.message);
    const label = field ? fieldLabelMap[field] || field : undefined;

    return {
      name: "ValidationError",
      field,
      message: label
        ? `Invalid value for ${label}`
        : "Invalid value provided to database",
    };
  }

  // JavaScript runtime errors
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
    };
  }

  // Fallback
  return {
    name: "UnknownError",
    message: String(error) || "An unknown error occurred.",
  };
}

/**
 * Utility for displaying in UI
 */
export function formatErrorForUI(error: any): string {
  const e = parseError(error);
  return e.message;
}


export function getErrorDialogMessage(error:any): string {
    const parsed = parseError(error);
    if (parsed.field) {
        return `${parsed.message} ${parsed.field}`
  } else {
    return parsed.message;
  }
}